import React from "react"
import { Navbar, Nav } from "react-bootstrap"
import { Link } from "react-router-dom"
import logo from '../../images/logo.png'
import Logout from '../authentication/Logout'


export default function NavbarComponent() {

 
  return (
    <Navbar bg="light" expand="sm">
      <Navbar.Brand as={Link} to="/">
        <img src={logo} alt='logo' style={{ maxWidth: '200px'}}></img>
      </Navbar.Brand>
      <Nav className="ml-auto">
        <Nav.Link as={Link} to="/user">
          Profile
        </Nav.Link>
        <Logout></Logout>
      </Nav>
    </Navbar>
  )
}
